<template>
  <div id="legal" class="page">
    <ContentBar :btns="false">
      <template #left>
        <div class="breadcrumbs flex-row">
          <BamLink :to="ROUTE.home" class="link-first flex-row">
            <span class="fw-m">BITSKINS.COM</span>
          </BamLink>
          <div class="links flex">
            <BamLink v-if="$route.name === ROUTE.terms_of_use" class="link flex-row" :to="ROUTE.terms_of_use">
              <img src="@/asset/icon/arrow-square.svg" class="img-arrow svg-green" alt="">
              <span>{{ $t('common.terms_of_use') }}</span>
            </BamLink>
            <BamLink v-if="$route.name === ROUTE.privacy_policy" class="link flex-row" :to="ROUTE.privacy_policy">
              <img src="@/asset/icon/arrow-square.svg" class="img-arrow svg-green" alt="">
              <span>{{ $t('common.privacy_policy') }}</span>
            </BamLink>
            <BamLink v-if="$route.name === ROUTE.cookie_policy" class="link flex-row" :to="ROUTE.cookie_policy">
              <img src="@/asset/icon/arrow-square.svg" class="img-arrow svg-green" alt="">
              <span>{{ $t('common.cookie_policy') }}</span>
            </BamLink>
          </div>
        </div>
      </template>
    </ContentBar>
    <NavBar>
      <template #nav>
        <Nav :list="nav_links" />
      </template>
    </NavBar>

    <div class="content">
      <slot />
    </div>
  </div>
</template>

<script setup>
import ContentBar from '@/component/items-page/ContentBar.vue';
import { ROUTE } from '@/facade/enum.js';
import BamLink from 'bambam-router/component/BamLink.vue';
import Nav from '@/component/inventory/Nav.vue';
import { computed } from 'vue';
import { deepMerge } from 'bambam-util/cherrypick.js';
import { slug } from '@/hook/market/game.js';
import NavBar from '@/component/body/NavBar.vue';

const nav_links = computed(() => [
  {
    name: 'common.terms_of_use',
    route: { name: ROUTE.terms_of_use },
  },
  {
    name: 'common.privacy_policy',
    route: { name: ROUTE.privacy_policy },
  },
  {
    name: 'common.cookie_policy',
    route: { name: ROUTE.cookie_policy },
  },
].map((o) => deepMerge(o, { route: { params: { game: slug.value } } })));
</script>
